export const name = "KLL_QUANTILES.EXTRACT_POINT_INT64";
export const summary = `Gets a specific quantile from an \`INT64\`-initialized KLL sketch.`;
export const reference = `
## KLL_QUANTILES.EXTRACT_POINT_INT64

Gets a specific quantile from an \`INT64\`-initialized KLL sketch.

\`\`\`
KLL_QUANTILES.EXTRACT_POINT_INT64(sketch, phi)
\`\`\`

### Description

Takes a single KLL sketch as \`BYTES\` and returns a single quantile. The \`phi\` argument specifies the quantile to return as a fraction of the total number of rows in the input, normalized between 0 and 1. This means that the function will return a value _v_ such that approximately Φ \\* _n_ inputs are less than or equal to _v_, and a (1-Φ) \\* _n_ inputs are greater than or equal to _v_. This is a scalar function.

Returns an error if the underlying type of the input sketch isn't compatible with type \`INT64\`.

Returns an error if the input isn't a valid KLL quantiles sketch.


### Supported Argument Types

- \`sketch\`: \`BYTES\` KLL sketch initialized on \`INT64\` data type
- \`phi\`: \`FLOAT64\` between 0 and 1


### Return Type

\`INT64\`


### Example

The following query initializes a KLL sketch from five rows of data. Then it returns the value of the eighth decile or 80th percentile of the sketch.



\`\`\`
SELECT KLL_QUANTILES.EXTRACT_POINT_INT64(kll_sketch, .8) AS quintile
FROM (SELECT KLL_QUANTILES.INIT_INT64(x, 1000) AS kll_sketch
      FROM (SELECT 1 AS x UNION ALL
            SELECT 2 AS x UNION ALL
            SELECT 3 AS x UNION ALL
            SELECT 4 AS x UNION ALL
            SELECT 5 AS x));

/*----------*
 | quintile |
 +----------+
 | 4 |
 *----------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
